import { useLocation } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import BackButton from "@/components/BackButton";
import ConciergeChat from "@/components/ConciergeChat";

// Routes that should NOT show the global BackButton.
// (Home / branch home pages already surface primary nav prominently.)
const NO_BACK_ROUTES = new Set(["/", "/hr", "/continuum"]);

// Routes that should NOT show the public concierge chat (authenticated / admin surfaces).
const NO_CHAT_PREFIXES = ["/admin", "/dashboard", "/portal", "/login", "/register", "/forgot-password", "/reset-password"];

export default function SiteLayout({ branch = "main", children, showBack }) {
  const location = useLocation();
  const showByDefault = !NO_BACK_ROUTES.has(location.pathname);
  const shouldShow = showBack ?? showByDefault;
  const showChat = !NO_CHAT_PREFIXES.some((p) => location.pathname.startsWith(p));

  return (
    <div className="min-h-screen flex flex-col bg-[var(--light)]">
      <SiteHeader branch={branch} />
      {shouldShow && <BackButton branch={branch} />}
      <main className="flex-1">{children}</main>
      <SiteFooter />
      {showChat && <ConciergeChat />}
    </div>
  );
}
